export default {
    'propriofalliti': new Set(['pagination failed', 'nothing to paginate']),
    'falliti': new Set(['validation failed', 'nothing to paginate', 'pagination failed']),
    'invalidati': new Set(['validation failed']),
    'completati': new Set(['pagination complete']),
    'running': new Set(['pagination in progress - running', 'pagination in progress - queued', 'queued', 'queued (validated)']),
    'terminati': new Set(['pagination complete', 'pagination failed', 'validation failed', 'nothing to paginate']),
}